<template>
	<!-- 联系我们 -->
	<div class="container contact">
		<div style="margin-top: 50px; margin-bottom: 50px; text-align: center">
			<img src="/img/about/contactus.png"/>
		</div>
		<div class="details-wrapper">
			<iframe src="map.html" width="790" height="300" frameborder="0" scrolling="no"></iframe>
			<div class="details">
				<div class="company" style="">成都交子金服科技股份有限公司</div>
				<div class="info">
					<div class="icon"><img src="/img/about/addr.png"/></div>
					<span class="name">地址：</span>
					<div class="desc">成都市高新区天府大道北段1677号<br/>交子金融科技中心A座224,225号</div>
				</div>
				<div class="info">
					<div class="icon"><img src="/img/about/tel.png"/></div>
					<span class="name">热线电话：</span>
					<div class="desc">028-68058766</div>
				</div>
				<!--
				<div class="info">
					<div class="icon"><img src="/img/about/mob.png"/></div>
					<span class="name">手机：</span>
					<div class="desc">13980010345 / 18628003723</div>
				</div>
				-->
<!--
				<div class="info">
					<div class="icon"><img src="/img/about/fax.png"/></div>

					<span class="name">传真：</span>
					<div class="desc">028-85231897</div>
				</div>
-->
			</div>
		</div>

	</div>
</template>

<script type="text/ecmascript-6">
	export default {
		name: 'AboutContact',
		data() {
			return {};
		}
	};
</script>

<style scoped lang="stylus" rel="stylesheet/stylus">
	@import "../../theme/mixin"

	.contact
		padding-bottom: 100px

	.details-wrapper
		clearfix()
		iframe
			float: left
			margin-right: 10px
		.details
			width: 400px
			height: 300px
			background: #f5f5f5
			float: left
			padding: 30px
			box-sizing: border-box
			.company
				text-align: center
				line-height: 36px
				font-size: 18px
				color: #323232
			.info
				display: flex
				flex-direction: row
				align-items: flex-start
				font-size: 16px
				line-height: 28px
				padding: 10px 0
				.icon
					width: 18px
					height: 28px
					position: relative
					img
						position: absolute
						top: 6px
						display: block
						margin: 0 auto
				.name
					padding-left: 5px
					padding-right: 10px
				.desc
					flex: 1
					color: #686868
</style>
